import { APP_AMOUNT_LOCALE } from '@/utils/constants';

/**
 * Formatowanie kwoty
 *
 * @export
 * @param {number| string} amount
 * @returns {string}
 */
export function formatAmount(amount: number | string): string {
  if (typeof amount !== 'number') {
    amount = parseFloat(amount.replace(',', '.'));
  }
  return (
    amount?.toLocaleString(APP_AMOUNT_LOCALE, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    }) || ''
  );
}
